import { IntlShape } from 'react-intl';
import { MeetingProgress } from '../api/control.dao';
import { SortOrder } from '../api/shared.dto';

export const MeetingProgressList: MeetingProgress[] = [
  MeetingProgress.STANDBY,
  MeetingProgress.READY,
  MeetingProgress.UNDERWAY,
  MeetingProgress.ENDED
];

export const MeetingProgressLabel = {
  [MeetingProgress.STANDBY]: 'Not Started',
  [MeetingProgress.READY]: 'Ready',
  [MeetingProgress.UNDERWAY]: 'Underway',
  [MeetingProgress.ENDED]: 'Ended'
};

export const meetingsSortOrdersLabels = (intl: IntlShape): Record<SortOrder, string> => ({
  [SortOrder.Asc]: intl.formatMessage({
    id: 'oe.meetings.meetingsSortOption.beginningToEnd',
    defaultMessage: 'Beginning to End',
    description: 'Button label'
  }),
  [SortOrder.Desc]: intl.formatMessage({
    id: 'oe.meetings.meetingsSortOption.endToBeginning',
    defaultMessage: 'End to Beginning',
    description: 'Button label'
  }),
});

export const SORT_MEETINGS_TEXT = {
    id: 'oe.meetings.sortMeetings',
    description: 'Label text',
    defaultMessage: 'Sort Meetings'
};

export const SCHEDULE_TAB_SELECTED_FILTERS = 'scheduleTabSelectedFilters';
export const CONTROL_TAB_SELECTED_FILTERS = 'controlTabSelectedFilters';
export const LOAD_SAVED_FILTERS = true;
export const TRACK_FILTERS = true;

export enum MEETING_ERRORS {
    EXTERNAL_ID_NO_UNIQUE = 'MEETING_EXTERNAL_ID_NO_UNIQUE'
};